import React from "react";

// @ts-ignore
export const ThemeContext = React.createContext(undefined);
